import { render, staticRenderFns } from "./NotifDispatcher.vue?vue&type=template&id=3a33ca93&"
import script from "./NotifDispatcher.vue?vue&type=script&lang=js&"
export * from "./NotifDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports